import { switchCollaboration } from '@/redux/ducks/document/list'
import React, { useContext, useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

const collaborationHeader = 'collaboration-id'

const CollaborationContext = React.createContext({ collaborationId: '', setCollaborationId: (_id) => {}, collaborationHeaders: {} })
export const CollaborationContextProvider = ({ children, value = {} }) => {
  const [collaborationId, setCollaborationId] = useState(null)
  const dispatch = useDispatch()
  const currentCollaboration = useSelector((state) => state.document.list.currentCollaboration)

  useEffect(() => {
    dispatch(switchCollaboration(collaborationId))

    return () => {
      dispatch(switchCollaboration(null))
    }
  }, [collaborationId])

  const collaborationHeaders = useMemo(() => {
    if (collaborationId) return { [`${collaborationHeader}`]: collaborationId }
    if (!currentCollaboration || currentCollaboration === 'internal') return {}
    return { [`${collaborationHeader}`]: currentCollaboration }
  }, [collaborationId, currentCollaboration])

  return <CollaborationContext.Provider value={{ ...value, collaborationId, setCollaborationId, collaborationHeaders }}>{children}</CollaborationContext.Provider>
}
export const useCollaborationContext = () => useContext(CollaborationContext)
